import React from 'react';
import styled from 'styled-components';
import { shade600, circle } from '@pleo-io/telescope-tokens';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */\n    margin-right: ", "px;\n    background-color: ", ";\n    border-radius: ", ";\n    animation: loadAnimation 1.8s infinite ease-in-out;\n    animation-delay: ", "s;\n    animation-fill-mode: both;\n\n    @keyframes loadAnimation {\n        0%,\n        80%,\n        100% {\n            transform: scale3d(0.3, 0.3, 1);\n        }\n\n        40% {\n            transform: scale3d(1.2, 1.2, 1);\n        }\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject());
var Dot = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2(), function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var size = _ref3.size;
  return size;
}, shade600, circle, function (_ref4) {
  var delay = _ref4.delay;
  return delay;
});

var Loading = function Loading(_ref5) {
  var size = _ref5.size,
      props = _objectWithoutPropertiesLoose(_ref5, ["size"]);

  return React.createElement(Wrapper, Object.assign({}, props), React.createElement(Dot, {
    delay: 0,
    size: size
  }), React.createElement(Dot, {
    delay: 0.16,
    size: size
  }), React.createElement(Dot, {
    delay: 0.32,
    size: size
  }));
};

export { Loading };